"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var CustomSuggestionItem = function CustomSuggestionItem(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder;
  var wrapperClassNames = (0, _classnames["default"])('display-flex align-items-center', 'padding-top-5 padding-bottom-5', !value && 'text-color-gray');
  var iconClassNames = (0, _classnames["default"])('margin-left--5 margin-right-5 margin-top--1', 'rioglyph', !value ? 'rioglyph-arrow-up' : 'rioglyph-plus');
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: wrapperClassNames
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: iconClassNames
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: 'text-italic'
  }, value || placeholder));
};
CustomSuggestionItem.defaultProps = {};
CustomSuggestionItem.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  placeholder: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
};
var _default = CustomSuggestionItem;
exports["default"] = _default;